import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

interface DeleteConfirmationProps {
  id: number;
  open: boolean;
  onDeleteConfirm: (id: number) => void;
  onCancel: () => void;
  title: string;
  content: string;
  /** Raise above elevated drawers/sidebars when needed */
  zIndex?: number;
  sx?: SxProps<Theme>;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  id,
  open,
  title,
  content,
  onDeleteConfirm,
  onCancel,
  zIndex,
  sx,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      sx={{
        zIndex: (theme) =>
          zIndex ?? theme.zIndex.drawer + 300,
        ...sx,
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">Cancel</Button>
        <Button onClick={() => onDeleteConfirm(id)} color="secondary">Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmation;
